import { EcommerceStoreYearlyRevenueOptions } from '../types/ecommerce-store-yearly-revenue';

export const RevenueOptions = [
  { id: EcommerceStoreYearlyRevenueOptions.Zero, name: '0' },
  { id: EcommerceStoreYearlyRevenueOptions.Less5k, name: 'txt_revenue_option_less_5k' },
  { id: EcommerceStoreYearlyRevenueOptions.From5kTo25k, name: 'txt_revenue_option_5k_25k' },
  { id: EcommerceStoreYearlyRevenueOptions.From25kTo50k, name: 'txt_revenue_option_25k_50k' },
  { id: EcommerceStoreYearlyRevenueOptions.From50To100k, name: 'txt_revenue_option_50k_100k' },
  { id: EcommerceStoreYearlyRevenueOptions.From100To500k, name: 'txt_revenue_option_100k_500k' },
  { id: EcommerceStoreYearlyRevenueOptions.Above500k, name: 'txt_revenue_option_500k_and_more' },
];
